/** Geometry of the MG logomark (viewBox 0 0 116 76). Shared by <LogoMark /> and the brand SVG files. */
export const MARK_VIEWBOX = '0 0 116 76'
export const MARK_ASPECT = 116 / 76
export const MARK_CYAN = '#0BC1E6'
export const MARK_RED = '#E20912'
/** Filled, geometric M with 10 unit stems. */
export const MARK_M_PATH = 'M8 52V8h10.5L30 27.5 41.5 8H52v44H42V25.5l-9 15h-6l-9-15V52z'
/** Rounded square G drawn as a 10 unit stroke. */
export const MARK_G_PATH = 'M108 13H80a11 11 0 0 0-11 11v12a11 11 0 0 0 11 11h12a11 11 0 0 0 11-11v-5H88'
/** Dashed circuit underlines. */
export const MARK_M_LINE = 'M8 64h44'
export const MARK_G_LINE = 'M64 64h34.6'
export const MARK_G_NODE = { cx: 104.8, cy: 64, r: 3.2 }
export const MARK_DASH = '6.4 3'
